import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { DatabaseBackup } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/vollsicherung`;
const dt = (v) => (v ? new Date(v).toLocaleString("de-DE") : "—");

const Zeile = ({ s, onPruefen }) => (
  <div className="border rounded-lg p-3 text-sm flex flex-wrap items-center gap-3" data-testid={`vs-row-${s.id}`}>
    <div className="flex-1 min-w-[220px]">
      <p className="font-medium">{dt(s.gestartet_am)} · {s.status === "fertig" ? "fertig" : s.status === "fehler" ? "Fehler" : "läuft …"}</p>
      <p className="text-xs text-muted-foreground">{s.grund} · {s.anzahl_dokumente ?? "…"} Datensätze · {s.anzahl_serverdateien ?? "…"} Server-Dateien · {s.fortschritt}</p>
      {s.fehler && <p className="text-xs text-red-600">{s.fehler}</p>}
      {s.pruefung && <p className={`text-xs ${s.pruefung.ok ? "text-green-700" : "text-red-600"}`}>
        Wiederherstellungs-Test {dt(s.pruefung.am)}: {s.pruefung.ok ? "bestanden – alle Datensätze vollständig" : `fehlgeschlagen ${s.pruefung.fehler || JSON.stringify(s.pruefung.abweichungen)}`}</p>}
    </div>
    {s.status === "fertig" && <Button size="sm" variant="outline" onClick={() => onPruefen(s.id)} data-testid={`vs-pruefen-${s.id}`}>Wiederherstellung testen</Button>}
  </div>
);

export const Vollsicherung = () => {
  const [liste, setListe] = useState([]);
  const laden = () => axios.get(API).then((r) => setListe(r.data)).catch(() => {});
  useEffect(() => { laden(); const t = setInterval(laden, 5000); return () => clearInterval(t); }, []);
  const start = async () => { await axios.post(`${API}/start`, { grund: "manuell vor Änderungen" }); toast.success("Vollsicherung gestartet"); laden(); };
  const pruefen = async (id) => { await axios.post(`${API}/${id}/pruefen`); toast.success("Test läuft – spielt die Sicherung in eine Test-Datenbank ein"); laden(); };
  return (
    <Card className="mb-6" data-testid="vollsicherung-card">
      <CardHeader><CardTitle className="flex items-center gap-2 text-lg"><DatabaseBackup className="w-5 h-5" />Datensicherung (Vollsicherung)</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-muted-foreground">Sichert alle Daten inkl. aller PDFs verlustfrei und mit Prüfsummen. „Wiederherstellung testen“ spielt die Sicherung in eine getrennte Test-Datenbank ein und vergleicht jeden Datensatz – Ihre echten Daten bleiben unberührt.</p>
        <Button onClick={start} disabled={liste[0]?.status === "laeuft"} data-testid="vs-start">Jetzt vollständig sichern</Button>
        {liste.map((s) => <Zeile key={s.id} s={s} onPruefen={pruefen} />)}
      </CardContent>
    </Card>
  );
};
